import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";

// Local
import { createFlagsReducer, defaultFlags } from "../flags";
import { navigationReducer } from "../navigation";
import { emailsReducer } from "../emails";

// Types
import type { Action, Reducer } from "redux";
import type { FirebaseReducer, FirestoreReducer } from "react-redux-firebase";
import type { History } from "history";
import type { RouterState } from "connected-react-router";
import type { FlagsState } from "../flags";
import type { NavigationState } from "../navigation";
import type { UserWorkspace } from "../users/types";
import type { EmailsState } from "../emails/state";

interface UserProfile {
  name: string;
  photoURL: string;
  workspaces: UserWorkspace[];
}
export interface AppState {
  readonly navigation: NavigationState;

  // Feature Flags
  readonly flags: FlagsState;

  // React Router
  readonly router: RouterState;

  // Firebase
  readonly firestore: FirestoreReducer.Reducer;
  readonly firebase: FirebaseReducer.Reducer<UserProfile>;

  readonly emails: EmailsState;
}

export type RootReducer = Reducer<AppState, Action>;

const rootReducer = (history: History): RootReducer =>
  combineReducers<AppState>({
    navigation: navigationReducer,
    flags: createFlagsReducer(defaultFlags()),
    router: connectRouter(history),
    firebase: firebaseReducer,
    firestore: firestoreReducer as Reducer,
    emails: emailsReducer,
  });

export default rootReducer;
